<div *ngIf="companySchedule && companySchedule.length > 0">
  <h4>{{ 'Opening Hours' | translate }}</h4>
  <div class="row font-weight-light">

    <div class="col">
        <span *ngFor="let schedule of companySchedule" [ngClass]="isTodayClass(schedule.indexDayOfWeek)">{{ getWeekDayName(schedule.indexDayOfWeek) }}<br/></span>
    </div>
    <div class="col">
        <span *ngFor="let schedule of companySchedule">{{ schedule.openHours | translate }}<br/></span>
    </div>
  </div>
</div>
